import { render, staticRenderFns } from "./CurriculumHeader.vue?vue&type=template&id=67412a10&scoped=true&"
import script from "./CurriculumHeader.vue?vue&type=script&lang=ts&"
export * from "./CurriculumHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumHeader.vue?vue&type=style&index=0&id=67412a10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67412a10",
  null
  
)

export default component.exports